<div *ngFor="let item of instance.externalLayers;">
  <div *ngIf="isLayerAddedToProject(item)" class="edit-project-layer">
    <div class="edit-project-layer-title">- {{item.name}}</div>
    <div class="edit-project-layer-action">
      <app-button
        *ngIf="item.index !== instance.externalLayers.length - 1"
        (click)="moveLayerUp(item)"
        [icon]="'arrow_upwards'"
      >
      </app-button>
      <app-button
        *ngIf="item.index !== 0"
        (click)="moveLayerDown(item)"
        [icon]="'arrow_downwards'"
      >
      </app-button>
      <mat-slide-toggle (click)="$event.stopPropagation()" [checked]="true" (change)="removeLayer(item)">
      </mat-slide-toggle>
    </div>
  </div>
</div>
<div *ngFor="let item of organizationUnit.externalLayers;">
  <div *ngIf="!isLayerAddedToProject(item) && item.name.length > 0" class="edit-project-layer">
    <div class="edit-project-layer-title">- {{item.name}}</div>
    <mat-slide-toggle (click)="$event.stopPropagation()" [checked]="false" (change)="addLayer(item)">
    </mat-slide-toggle>
  </div>
</div>
